import { gsap } from "gsap";

const showSearchButton = document.querySelector(".show-search-button");
const searchForm = document.getElementById("news-search-form");
const mql = window.matchMedia("(max-width: 1023px)");
const desktopMql = window.matchMedia("(min-width: 1024px)");

function showSearch(event) {
    const state = this.getAttribute("aria-expanded");

    if (state === "false" && mql.matches) {
        this.setAttribute("aria-expanded", "true");
        gsap.to(searchForm, { duration: 0.3, height: "auto", autoAlpha: 1 });
    }

    if (state === "true" && mql.matches) {
        this.setAttribute("aria-expanded", "false");
        gsap.to(searchForm, { duration: 0.3, height: 0, autoAlpha: 0 });
    }
}

if (showSearchButton && searchForm) showSearchButton.addEventListener("click", showSearch);

desktopMql.addEventListener("change", (e) => {
    if (e.matches) {
        if (searchForm && searchForm.getAttribute("style") !== null) {
            searchForm.removeAttribute("style");
            showSearchButton.setAttribute("aria-expanded", "false");
        }
    }
});
